import {Inject, Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  Purpose,
  PurposeCreateRequest,
  PurposeCreateResponse,
  PurposeDetails,
  PurposeUpdateRequest,
  PurposeUpdateResponse
} from '@ms-organization-entities';
import {ApiClientConfig} from '../api-client-config';
import {PriorityPatchRequest} from '@primatoo-ms-organization';
import {ColumnWithLocalization} from 'it/primatoo/openapi/api/org/schemas/common/ColumnWithLocalization';

import {DataProtectionGovernanceService} from '../interface';

@Injectable({
  providedIn: 'root'
})
export class PurposeService extends DataProtectionGovernanceService {
  private readonly endpoint: string;

  constructor(
    @Inject(ApiClientConfig) private config,
    public httpClient: HttpClient
  ) {
    super(httpClient);
    this.endpoint = this.config.endPoint + '/api/org/purposes/';
  }


  public getPurposeCategories(): Observable<Purpose[]> {
    const url = this.endpoint;
    return this.httpClient.get<Purpose[]>(url);
  }

  setPriority(id: number, request: PriorityPatchRequest): Observable<Purpose> {
    const url = `${this.endpoint}${id}/priority`;
    return this.httpClient.patch<Purpose>(url, request);
  }

  public findUserColumns(): Observable<ColumnWithLocalization[]> {
    const url = this.endpoint + `columns`;
    return this.httpClient.get<ColumnWithLocalization[]>(url);
  }

  public getPurposeCategoriesById(id: number): Observable<Purpose> {
    const url = this.endpoint + id + '/';
    return this.httpClient.get<Purpose>(url);
  }

  public deletePurpose(id: number): Observable<void> {
    const url = this.endpoint + id + '/';
    return this.httpClient.delete<void>(url);
  }

  public createPurpose(requestBody: PurposeCreateRequest): Observable<PurposeCreateResponse> {
    const url = this.endpoint;
    return this.httpClient.post<PurposeCreateResponse>(url, requestBody);
  }

  public updatePurpose(id: number, requestBody: PurposeUpdateRequest): Observable<PurposeUpdateResponse> {
    const url = this.endpoint + id + '/';
    return this.httpClient.put<PurposeUpdateResponse>(url, requestBody);
  }

  public getPurposeDetails(id: number): Observable<PurposeDetails> {
    const url = this.endpoint + id + '/details';
    return this.httpClient.get<PurposeDetails>(url);
  }

  getEndPointV1(): string {
    return this.endpoint;
  }

  public getCategories(): Observable<string[]> {
    const url = this.endpoint + 'categories/';
    return this.httpClient.get<string[]>(url);
  }

}
